module.exports = __webpack_public_path__ + "img/icon_selection.9a837553.svg";